module.exports = __webpack_public_path__ + "static/media/undraw_Map_dark_k9pw.052304ba.svg";